<template>
  <NotificationToast />
  <LayoutPageHeader
    :locale="false"
    class="sticky! top-0 z-40 bg-white/70! backdrop-blur-sm"
  >
    <div class="relative flex w-full items-center justify-between">
      <div class="flex-1">
        <LogoSvg class="size-10 flex-1" />
      </div>
      <OnboardingProgressIndicator />
      <div class="inline-flex w-full flex-1 justify-end">
        <div>
          <HubLocaleSwitcher class="w-full" />
        </div>
      </div>
    </div>
  </LayoutPageHeader>
  <div class="mx-auto mt-4 flex w-full max-w-4xl flex-col p-6 sm:p-10">
    <slot />
  </div>
</template>
<style>
@reference "tailwindcss";

.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}
.page-enter-from {
  opacity: 0;
  @apply translate-x-10;
}
.page-leave-to {
  opacity: 0;
  @apply -translate-x-10;
}
</style>
